import { render, staticRenderFns } from "./customerManagement.vue?vue&type=template&id=ddfb6e48&scoped=true&"
import script from "./customerManagement.vue?vue&type=script&lang=js&"
export * from "./customerManagement.vue?vue&type=script&lang=js&"
import style0 from "./customerManagement.vue?vue&type=style&index=0&id=ddfb6e48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfb6e48",
  null
  
)

export default component.exports